import { BatteryMediumIcon, BikeIcon } from 'lucide-react';

export interface ExtraMarker {
  coords: [number, number];
  kind: 'battery' | 'offer';
  reportedAt: string | null;
  courierId?: string | number;
  batteryPct?: number | null;
}

export function CourierMarker({
  color,
  hint,
  battery = false,
}: {
  color: string;
  hint?: string | undefined;
  battery?: boolean;
}) {
  const Icon = battery ? BatteryMediumIcon : BikeIcon;
  return (
    <span
      title={hint}
      className="flex size-9 items-center justify-center rounded-full border-[3px] border-white text-white shadow-lg"
      style={{ backgroundColor: color }}
    >
      <Icon className="size-5" />
    </span>
  );
}
